import { createFeatureSelector, createSelector } from "@ngrx/store";

import {
  AuthState,
  getError,
  getLoading,
  getToken,
  getJwtToken,
  getIsAuthenticated,
  getUsername
} from "../reducers";

export const selectAuthState = createFeatureSelector<AuthState>("auth");

export const selectAuthStatus = createSelector(
  selectAuthState,
  (state: AuthState) => state.status
);

export const selectError = createSelector(
  selectAuthStatus,
  getError
);

export const selectLoading = createSelector(
  selectAuthStatus,
  getLoading
);

export const selectToken = createSelector(
  selectAuthStatus,
  getToken
);

export const selectJwtToken = createSelector(
  selectAuthStatus,
  getJwtToken
);

export const selectIsAuthenticated = createSelector(
  selectAuthStatus,
  getIsAuthenticated
);

export const selectUsername = createSelector(
  selectAuthStatus,
  getUsername
);
